import React, { useState } from "react";
import axios from "axios";
import { UserPlus, ClipboardPaste, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const input = "w-full px-3 py-2 bg-[#FBF9F4] border border-gray-200 rounded-xl text-xs";

export default function CorporateEmployeeForm({ onAdded, onError }) {
  const [mode, setMode] = useState("single");
  const [single, setSingle] = useState({ name: "", email: "", phone: "", age: "", gender: "Male", employee_code: "", department: "" });
  const [bulk, setBulk] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    let employees = [];
    if (mode === "single") {
      employees = [{ ...single, age: single.age ? Number(single.age) : null }];
    } else {
      employees = bulk.split("\n").map((l) => l.trim()).filter(Boolean).map((l) => {
        const [name = "", email = "", phone = "", department = ""] = l.split(",").map((x) => x.trim());
        return { name, email, phone, department, gender: "Other" };
      });
    }
    setSaving(true);
    try {
      const res = await axios.post(`${API}/corporate/employees`, { employees }, { withCredentials: true });
      onAdded(res.data.added);
      setSingle({ name: "", email: "", phone: "", age: "", gender: "Male", employee_code: "", department: "" });
      setBulk("");
    } catch (err) {
      onError(err.response?.data?.detail || "Could not add employees");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="corp-employee-form">
      <div className="flex gap-1 bg-[#FBF9F4] p-1 rounded-xl w-fit text-xs font-semibold">
        <button type="button" data-testid="corp-emp-mode-single" onClick={() => setMode("single")} className={`px-3 py-1.5 rounded-lg flex items-center gap-1.5 ${mode === "single" ? "bg-[#0D3B2E] text-white" : "text-gray-600"}`}><UserPlus className="w-3.5 h-3.5" /> Single</button>
        <button type="button" data-testid="corp-emp-mode-bulk" onClick={() => setMode("bulk")} className={`px-3 py-1.5 rounded-lg flex items-center gap-1.5 ${mode === "bulk" ? "bg-[#0D3B2E] text-white" : "text-gray-600"}`}><ClipboardPaste className="w-3.5 h-3.5" /> Paste list</button>
      </div>
      {mode === "single" ? (
        <div className="grid sm:grid-cols-3 gap-2">
          <input required placeholder="Full name *" value={single.name} onChange={(e) => setSingle({ ...single, name: e.target.value })} data-testid="corp-emp-name" className={input} />
          <input type="email" placeholder="Work email" value={single.email} onChange={(e) => setSingle({ ...single, email: e.target.value })} data-testid="corp-emp-email" className={input} />
          <input placeholder="Phone" value={single.phone} onChange={(e) => setSingle({ ...single, phone: e.target.value })} data-testid="corp-emp-phone" className={input} />
          <input type="number" min={18} max={80} placeholder="Age" value={single.age} onChange={(e) => setSingle({ ...single, age: e.target.value })} data-testid="corp-emp-age" className={input} />
          <select value={single.gender} onChange={(e) => setSingle({ ...single, gender: e.target.value })} data-testid="corp-emp-gender" className={input}><option>Male</option><option>Female</option><option>Other</option></select>
          <input placeholder="Employee code / Dept" value={single.employee_code} onChange={(e) => setSingle({ ...single, employee_code: e.target.value })} data-testid="corp-emp-code" className={input} />
        </div>
      ) : (
        <textarea rows={5} value={bulk} onChange={(e) => setBulk(e.target.value)} data-testid="corp-emp-bulk" placeholder={"One employee per line:\nName, email, phone, department\nRiya Sen, riya@acme.in, +91 98300 11111, Finance"} className={`${input} font-mono`} />
      )}
      <button type="submit" disabled={saving} data-testid="corp-emp-submit-btn" className="px-5 py-2.5 bg-[#0D3B2E] hover:bg-[#165644] text-white text-xs font-semibold rounded-xl flex items-center gap-2">
        {saving ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <UserPlus className="w-3.5 h-3.5" />} Add to roster
      </button>
    </form>
  );
}
